const validate = (values) => {
  const attrs = values || {};
  const errors = {};

  if (!attrs.nombre) {
    errors.nombre = 'Debe ingresar un nombre para el periodo';
  }

  if (!attrs.anhoLectivo || !attrs.anhoLectivo.value) {
    errors.anhoLectivo = 'Debe seleccionar el año lectivo';
  }

  if (!attrs.inicioClases) {
    errors.inicioClases = 'Debe seleccionar la fecha de inicio de clases';
  }

  if (!attrs.finClases) {
    errors.finClases = 'Debe seleccionar la fecha de fin de clases';
  }

  if (!attrs.inicioPeriodoInscripcion) {
    errors.inicioPeriodoInscripcion = 'Debe seleccionar la fecha de inicio de inscripciones';
  }

  if (!attrs.finPeriodoInscripcion) {
    errors.finPeriodoInscripcion = 'Debe seleccionar la fecha de fin de inscripciones';
  }

  return errors;
};

export default validate;
